import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import globals from '@/globals'
import Vuelidate from 'vuelidate'
import VuelidateErrorExtractor, { templates } from "vuelidate-error-extractor"; //IMPORT VuelidateErrorExtractor

// Layouts
import Layout1 from '@/layout/LayoutBlank'
import LayoutLanding from '@/layout/LayoutLanding'
import LayoutAuth from '@/layout/Layout2'
import LayoutDMS from '@/layout/Layoutdms'


//Role Helper
import { Role } from '@/helper/role';

Vue.use(Router)
Vue.use(Meta)
Vue.use(Vuelidate) //DEFINE AS GLOBAL

useEslint: false
//DEFINE ERROR MESSAGE
Vue.use(VuelidateErrorExtractor, {
  i18n: false,
  messages: {
    required: "{attribute} is required!",
    notGmail: "{attribute} must gmail address",
    notPhone: "{attribute} must phone number Indonesia format",
    email: "{attribute} is not a valid Email address.",
    isEmailAvailable:
      "{attribute} is not available. Must be at least 10 characters long."
  }
});

window._ = {};
window._.merge = require("lodash/merge");
window._.forEach = require("lodash/forEach");

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/login',
      component: Layout1,
      children: [{
        path: '',
        component: () => import('@/components/pages/auth/Login')
      }]
    },

    {
      path: '/register',
      component: Layout1,
      children: [{
        path: '',
        component: () => import('@/components/pages/auth/Register')
      }]
    },
    {
      path: '/dms',
      component: LayoutDMS,
      children: [{
        path: '',
        component: () => import('@/components/pages/dms/Index')
      }]
    },

    {
      path: '/',
      component: LayoutLanding,
      children: [
        {
          path: '',
          component: () => import('@/components/pages/landing/Index')
        },
        {
          path: '/lapor',
          component: () => import('@/components/pages/landing/Lapor')
        },
        {
          path: '/lapor/pesk',
          component: () => import('@/components/pages/landing/Pesk/Form')
        },
        {
          path: '/lapor/alkes',
          component: () => import('@/components/pages/landing/Alkes/Form')
        },


      ]
    },

    {
      path: '/app',
      component: LayoutAuth,
      children: [
        {
          path: '',
          component: () => import('@/components/pages/dashboard/Dashboard')
        },
        //Merkuri

        {
          path: 'merkuri/alkes',
          component: () => import('@/components/pages/Merkuri/Alkes')
        },
        {
          path: 'merkuri/pesk',
          component: () => import('@/components/pages/Merkuri/Pesk')
        },
        {
          path: 'merkuri/alkes/preview/:id',
          component: () => import('@/components/pages/Merkuri/PrevAlkes'),
        },
        {
          path: 'merkuri/alkes/edit/preview/:id',
          component: () => import('@/components/pages/Merkuri/EditPrevAlkes'),
        },
        {
          path: 'merkuri/pesk/preview/:id',
          component: () => import('@/components/pages/Merkuri/PrevPesk'),
        },
        {
          path: 'merkuri/pesk/edit/preview/:id',
          component: () => import('@/components/pages/Merkuri/EditPrevPesk'),
        },

        //Laporkan
        {
          path: 'laporkan',
          component: () => import('@/components/pages/Laporkan/Index')
        },
        {
          path: 'laporkan/pesk',
          component: () => import('@/components/pages/Laporkan/pesk/Index')
        },
        {
          path: 'laporkan/pesk/create',
          component: () => import('@/components/pages/Laporkan/pesk/Create')
        },
        {
          path: 'laporkan/alkes',
          component: () => import('@/components/pages/Laporkan/alkes/Index')
        },
        {
          path: 'laporkan/alkes/create',
          component: () => import('@/components/pages/Laporkan/alkes/Create')
        },

        {
          path: 'penjemputan/pelapor',
          component: () => import('@/components/pages/Pelapor/Penjemputan')
        },

        {
          path: 'riwayat/pelapor',
          component: () => import('@/components/pages/Pelapor/Riwayat')
        },

        {
          path: 'tes/pusher',
          component: () => import('@/components/pages/tes/Tes')
        },

        {
          path: 'masterdata',
          component: () => import('@/components/pages/master_data/Index'),
        },
        {
          path: 'borangmasteralkes',
          component: () => import('@/components/pages/master_data/BorangMasterAlkes'),
        },

        // WMS
        {
          path: 'wms/receiving',
          component: () => import('@/components/pages/Wms/Receiving')
        },

        {
          path: 'wms/receiving/alkes/thermometer',
          component: () => import('@/components/pages/Wms/Receiving/Thermometer')
        },

        {
          path: 'wms/receiving/alkes/tensimeter',
          component: () => import('@/components/pages/Wms/Receiving/Tensimeter')
        },

        {
          path: 'wms/receiving/alkes/amalgam',
          component: () => import('@/components/pages/Wms/Receiving/Amalgam')
        },

        //WMS PROVINSI
        {
          path: 'wms/pesk/provinsi/receiving',
          component: () => import('@/components/pages/Wms/Receiving/Provinsi/Receiving')
        },

        {
          path: 'wms/receiving/alkes/provinsi/thermometer',
          component: () => import('@/components/pages/Wms/Receiving/Provinsi/Thermometer')
        },


        {
          path: 'wms/receiving/alkes/provinsi/tensimeter',
          component: () => import('@/components/pages/Wms/Receiving/Provinsi/Tensimeter')
        },

        {
          path: 'wms/receiving/alkes/provinsi/amalgam',
          component: () => import('@/components/pages/Wms/Receiving/Provinsi/Amalgam')
        },


        //WMS FINAL
        {
          path: 'wms/pesk/final/receiving',
          component: () => import('@/components/pages/Wms/Receiving/Final/Receiving')
        },

        {
          path: 'wms/receiving/alkes/final/thermometer',
          component: () => import('@/components/pages/Wms/Receiving/Final/Thermometer')
        },

        {
          path: 'wms/receiving/alkes/final/tensimeter',
          component: () => import('@/components/pages/Wms/Receiving/Final/Tensimeter')
        },

        {
          path: 'wms/receiving/alkes/final/amalgam',
          component: () => import('@/components/pages/Wms/Receiving/Final/Amalgam')
        },


        //stock take alkes
        {
          path: 'wms/stock',
          component: () => import('@/components/pages/Wms/Stock Take/Alkes/Index')
        },

        {
          path: 'wms/stock/detail/barang/alkes/secondary/:id',
          component: () => import('@/components/pages/Wms/Stock Take/Alkes/StockBarangSecondary')
        },

        {
          path: 'wms/stock/take/primary/:id',
          component: () => import('@/components/pages/Wms/Stock Take/Alkes/Primary')
        },

        //stock take provinsi
        {
          path: 'wms/stock/provinsi',
          component: () => import('@/components/pages/Wms/Stock Take/Provinsi/Index')
        },

        {
          path: 'wms/stock/provinsi/storage',
          component: () => import('@/components/pages/Wms/Stock Take/Provinsi/Storage')
        },

        {
          path: 'wms/stock/take/provinsi/storage/:id',
          component: () => import('@/components/pages/Wms/Stock Take/Provinsi/IndexStorage')
        },

        {
          path: 'wms/stock/provinsi/agent',
          component: () => import('@/components/pages/Wms/Stock Take/Provinsi/Agent')
        },

        {
          path: 'wms/stock/take/provinsi/agent/:id',
          component: () => import('@/components/pages/Wms/Stock Take/Provinsi/IndexAgent')
        },

        //stock take final
        {
          path: 'wms/stock/final',
          component: () => import('@/components/pages/Wms/Stock Take/Final/Index')
        },

        {
          path: 'wms/stock/final/agent',
          component: () => import('@/components/pages/Wms/Stock Take/Final/Agent')
        },

        {
          path: 'wms/stock/take/final/agent/:id',
          component: () => import('@/components/pages/Wms/Stock Take/Final/IndexAgent')
        },



        //stock take pesk
        {
          path: 'wms/stock',
          component: () => import('@/components/pages/Wms/Detail/Stock')
        },
        {
          path: 'wms/stock/detail/:id',
          component: () => import('@/components/pages/Wms/Detail/Stock')
        },



        {
          path: 'wms/stock/detail/barang/secondary/:id',
          component: () => import('@/components/pages/Wms/Detail/StockBarangSecondary')
        },

        {
          path: 'wms/dispatching',
          component: () => import('@/components/pages/Wms/dispatching/Index')
        },

        {
          path: 'wms/dispatching/:code',
          component: () => import('@/components/pages/Wms/dispatching/Detail')
        },

        //dispatching agent
        {
          path: 'wms/agent/dispatching',
          component: () => import('@/components/pages/Wms/dispatching/Agent/Index')
        },


        //reporting kabupaten
        //reporting alkes
        {
          path: 'wms/reporting/alkes',
          component: () => import('@/components/pages/Wms/ReportingAlkes')
        },
        //reporting pesk
        {
          path: 'wms/reporting',
          component: () => import('@/components/pages/Wms/Reporting')
        },

        //reporting provinsi
        //reporting alkes
        {
          path: 'wms/reporting/provinsi/alkes',
          component: () => import('@/components/pages/Wms/Reporting/Provinsi/Alkes')
        },

        {
          path: 'wms/reporting/provinsi/alkes/storage',
          component: () => import('@/components/pages/Wms/Reporting/Provinsi/AgentStorage')
        },

        {
          path: 'wms/reporting/provinsi/alkes/storage/:id',
          component: () => import('@/components/pages/Wms/Reporting/Provinsi/AlkesStorage')
        },

        {
          path: 'wms/reporting/provinsi/pesk/storage',
          component: () => import('@/components/pages/Wms/Reporting/Provinsi/AgentPeskStorage')
        },

        {
          path: 'wms/reporting/provinsi/pesk/storage/:id',
          component: () => import('@/components/pages/Wms/Reporting/Provinsi/PeskStorage')
        },

        {
          path: 'wms/reporting/provinsi/alkes/agent',
          component: () => import('@/components/pages/Wms/Reporting/Provinsi/AgentAlkes')
        },

        {
          path: 'wms/reporting/provinsi/alkes/agent/:id',
          component: () => import('@/components/pages/Wms/Reporting/Provinsi/AlkesAgent')
        },

        //reporting pesk
        {
          path: 'wms/reporting/provinsi/pesk',
          component: () => import('@/components/pages/Wms/Reporting/Provinsi/Pesk')
        },

        {
          path: 'wms/reporting/provinsi/pesk/agent',
          component: () => import('@/components/pages/Wms/Reporting/Provinsi/AgentPesk')
        },

        {
          path: 'wms/reporting/provinsi/pesk/agent/:id',
          component: () => import('@/components/pages/Wms/Reporting/Provinsi/PeskAgent')
        },



        //reporting final
        //reporting alkes
        {
          path: 'wms/reporting/final/alkes',
          component: () => import('@/components/pages/Wms/Reporting/Final/Alkes')
        },
        {
          path: 'wms/reporting/final/alkes/agent',
          component: () => import('@/components/pages/Wms/Reporting/Final/AgentAlkes')
        },
        {
          path: 'wms/reporting/final/alkes/agent/:id',
          component: () => import('@/components/pages/Wms/Reporting/Final/AlkesAgent')
        },
        //reporting pesk
        {
          path: 'wms/reporting/final/pesk',
          component: () => import('@/components/pages/Wms/Reporting/Final/Pesk')
        },

        {
          path: 'wms/reporting/final/pesk/agent',
          component: () => import('@/components/pages/Wms/Reporting/Final/AgentPesk')
        },

        {
          path: 'wms/reporting/final/pesk/agent/:id',
          component: () => import('@/components/pages/Wms/Reporting/Final/PeskAgent')
        },

        //pengemasan kabupaten alkes 
        {
          path: 'wms/pengemasan/ulang/thermometer',
          component: () => import('@/components/pages/Wms/PengemasanUlang/Thermometer')
        },
        {
          path: 'wms/pengemasan/ulang/tensimeter',
          component: () => import('@/components/pages/Wms/PengemasanUlang/Tensimeter')
        },

        {
          path: 'wms/pengemasan/ulang/amalgam',
          component: () => import('@/components/pages/Wms/PengemasanUlang/Amalgam')
        },

        //pengemasan kabupaten pesk
        {
          path: 'wms/pengemasan/ulang',
          component: () => import('@/components/pages/Wms/PengemasanUlang/Pesk')
        },
        {
          path: 'wms/pengemasan/ulang/detail/:id',
          component: () => import('@/components/pages/Wms/Detail/PengemasanUlang')
        },


        //pengemasan provinsi alkes 
        {
          path: 'wms/pengemasan/ulang/provinsi/thermometer',
          component: () => import('@/components/pages/Wms/PengemasanUlang/Provinsi/Thermometer')
        },


        {
          path: 'wms/pengemasan/ulang/provinsi/tensimeter',
          component: () => import('@/components/pages/Wms/PengemasanUlang/Provinsi/Tensimeter')
        },



        {
          path: 'wms/pengemasan/ulang/provinsi/amalgam',
          component: () => import('@/components/pages/Wms/PengemasanUlang/Provinsi/Amalgam')
        },



        //pengemasan provinsi pesk
        {
          path: 'wms/pengemasan/ulang/provinsi',
          component: () => import('@/components/pages/Wms/PengemasanUlang/Provinsi/Pesk')
        },




        //pengemasan final alkes 
        {
          path: 'wms/pengemasan/ulang/final/thermometer',
          component: () => import('@/components/pages/Wms/PengemasanUlang/Final/Thermometer')
        },
        {
          path: 'wms/pengemasan/ulang/final/tensimeter',
          component: () => import('@/components/pages/Wms/PengemasanUlang/Final/Tensimeter')
        },

        {
          path: 'wms/pengemasan/ulang/final/amalgam',
          component: () => import('@/components/pages/Wms/PengemasanUlang/Final/Amalgam')
        },

        //pengemasan final pesk
        {
          path: 'wms/pengemasan/ulang/final',
          component: () => import('@/components/pages/Wms/PengemasanUlang/Final/Pesk')
        },







        //master data wms
        {
          path: 'masterwms',
          component: () => import('@/components/pages/master_data/MasterWMS'),
        },
        {
          path: 'masterwms/storage-management',
          component: () => import('@/components/pages/master_data/management_wms/management_storage/Index')
        },
        {
          path: 'masterwms/storage-management/create',
          component: () => import('@/components/pages/master_data/management_wms/management_storage/Create')
        },
        {
          path: 'masterwms/storage-management/edit/:id',
          component: () => import('@/components/pages/master_data/management_wms/management_storage/Edit')
        },
        {
          path: 'masterwms/storage-management/detail/:id',
          component: () => import('@/components/pages/master_data/management_wms/management_storage/Sektor/Index')
        },
        {
          path: 'masterwms/sektor-management/create/:id',
          component: () => import('@/components/pages/master_data/management_wms/management_storage/Sektor/Create'),
        },

        {
          path: 'masterwms/sektor-management/edit/:id',
          component: () => import('@/components/pages/master_data/management_wms/management_storage/Sektor/Edit'),
        },

        //MASTER WADAH
        {
          path: 'masterwadah',
          component: () => import('@/components/pages/master_data/MasterWadah'),
        },

        //Primary master data wadah
        {
          path: 'masterwadah/alkes',
          component: () => import('@/components/pages/master_data/wadah/management_wadah_alkes/Index'),
        },
        {
          path: 'masterwadah/alkes/create',
          component: () => import('@/components/pages/master_data/wadah/management_wadah_alkes/Create'),
        },

        {
          path: 'masterwadah/alkes/edit/:id',
          component: () => import('@/components/pages/master_data/wadah/management_wadah_alkes/Edit')
        },
        //primer pesk
        {
          path: 'masterwadah/pesk',
          component: () => import('@/components/pages/master_data/wadah/management_wadah_pesk/Index')
        },

        {
          path: 'masterwadah/pesk/create',
          component: () => import('@/components/pages/master_data/wadah/management_wadah_pesk/Create')
        },

        {
          path: 'masterwadah/pesk/edit/:id',
          component: () => import('@/components/pages/master_data/wadah/management_wadah_pesk/Edit')
        },

        // Secondary pesk
        {
          path: 'masterwadah/pesk/secondary',
          component: () => import('@/components/pages/master_data/wadah/management_wadah_pesk_secondary/Index')
        },

        {
          path: 'masterwadah/pesk/secondary/create',
          component: () => import('@/components/pages/master_data/wadah/management_wadah_pesk_secondary/Create')
        },

        {
          path: 'masterwadah/pesk/secondary/edit/:id',
          component: () => import('@/components/pages/master_data/wadah/management_wadah_pesk_secondary/Edit')
        },

        // Secondary Alkes
        {
          path: 'masterwadah/alkes/secondary',
          component: () => import('@/components/pages/master_data/wadah/management_wadah_alkes_secondary/Index')
        },
        {
          path: 'masterwadah/alkes/secondary/create',
          component: () => import('@/components/pages/master_data/wadah/management_wadah_alkes_secondary/Create')
        },


        // SHIPPING


        // SHIPPING PESK INTERIM
        {
          path: 'shipping/pesk/interim',
          component: () => import('@/components/pages/shipping/shippingpeskinterim/Index')
        },
        {
          path: 'shipping/pesk/interim/detail/:code',
          component: () => import('@/components/pages/shipping/shippingpeskinterim/Detail')
        },
        {
          path: 'shipping/pesk/interim/pengemasan/:code',
          component: () => import('@/components/pages/shipping/shippingpeskinterim/Pengemasan')
        },
        {
          path: 'shipping/pesk/interim/management/:code',
          component: () => import('@/components/pages/shipping/shippingpeskinterim/Management')
        },
        {
          path: 'shipping/pesk/interim/result/:code',
          component: () => import('@/components/pages/shipping/shippingpeskinterim/Result')
        },


        // SHIPPING ALKES INTERIM
        {
          path: 'shipping/alkes/interim',
          component: () => import('@/components/pages/shipping/shippingalkesinterim/Index')
        },
        {
          path: 'shipping/alkes/interim/detail/:code',
          component: () => import('@/components/pages/shipping/shippingalkesinterim/Detail')
        },
        {
          path: 'shipping/alkes/interim/pengemasan/:code',
          component: () => import('@/components/pages/shipping/shippingalkesinterim/Pengemasan')
        },
        {
          path: 'shipping/alkes/interim/management/:code',
          component: () => import('@/components/pages/shipping/shippingalkesinterim/Management')
        },
        {
          path: 'shipping/alkes/interim/result/:code',
          component: () => import('@/components/pages/shipping/shippingalkesinterim/Result')
        },




        // Shipping PESK PROVINSI
        {
          path: 'shipping/pesk/provinsi',
          component: () => import('@/components/pages/shipping/shippingpeskprovinsi/Index')
        },
        {
          path: 'shipping/pesk/provinsi/storage',
          component: () => import('@/components/pages/shipping/shippingpeskprovinsi/Storage')
        },
        {
          path: 'shipping/pesk/provinsi/storage/:id',
          component: () => import('@/components/pages/shipping/shippingpeskprovinsi/Create')
        },
        {
          path: 'shipping/pesk/provinsi/management/:code',
          component: () => import('@/components/pages/shipping/shippingpeskprovinsi/Management')
        },
        {
          path: 'shipping/pesk/provinsi/result/:code',
          component: () => import('@/components/pages/shipping/shippingpeskprovinsi/Result')
        },


        // SHIPPING ALKES PROVINSI
        {
          path: 'shipping/alkes/provinsi',
          component: () => import('@/components/pages/shipping/shippingalkesprovinsi/Index')
        },
        {
          path: 'shipping/alkes/provinsi/storage',
          component: () => import('@/components/pages/shipping/shippingalkesprovinsi/Storage')
        },
        {
          path: 'shipping/alkes/provinsi/storage/:id',
          component: () => import('@/components/pages/shipping/shippingalkesprovinsi/Create')
        },
        {
          path: 'shipping/alkes/provinsi/management/:code',
          component: () => import('@/components/pages/shipping/shippingalkesprovinsi/Management')
        },
        {
          path: 'shipping/alkes/provinsi/result/:code',
          component: () => import('@/components/pages/shipping/shippingalkesprovinsi/Result')
        },



        // SHIPPING APPROVAL ADMIN PESK
        {
          path: 'shipping/pesk/approval',
          component: () => import('@/components/pages/shipping/shippingapprovalpesk/Index')
        },
        {
          path: 'shipping/pesk/approval/detail/:code',
          component: () => import('@/components/pages/shipping/shippingapprovalpesk/Detail')
        },

        // SHIPPING APPROVAL ADMIN ALKES
        {
          path: 'shipping/alkes/approval',
          component: () => import('@/components/pages/shipping/shippingapprovalalkes/Index')
        },
        {
          path: 'shipping/alkes/approval/detail/:code',
          component: () => import('@/components/pages/shipping/shippingapprovalalkes/Detail')
        },



        // SHIPPING FINAL PESK
        {
          path: 'shipping/pesk/final',
          component: () => import('@/components/pages/shipping/shippingpeskfinal/Index')
        },
        {
          path: 'shipping/pesk/final/storage',
          component: () => import('@/components/pages/shipping/shippingpeskfinal/Storage')
        },
        {
          path: 'shipping/pesk/final/storage/:id',
          component: () => import('@/components/pages/shipping/shippingpeskfinal/Create')
        },
        {
          path: 'shipping/pesk/final/management/:code',
          component: () => import('@/components/pages/shipping/shippingpeskfinal/Management')
        },
        {
          path: 'shipping/pesk/final/result/:code',
          component: () => import('@/components/pages/shipping/shippingpeskfinal/Result')
        },

        // SHIPPING FINAL ALKES
        {
          path: 'shipping/alkes/final',
          component: () => import('@/components/pages/shipping/shippingalkesfinal/Index')
        },
        {
          path: 'shipping/alkes/final/storage',
          component: () => import('@/components/pages/shipping/shippingalkesfinal/Storage')
        },
        {
          path: 'shipping/alkes/final/storage/:id',
          component: () => import('@/components/pages/shipping/shippingalkesfinal/Create')
        },
        {
          path: 'shipping/alkes/final/management/:code',
          component: () => import('@/components/pages/shipping/shippingalkesfinal/Management')
        },
        {
          path: 'shipping/alkes/final/result/:code',
          component: () => import('@/components/pages/shipping/shippingalkesfinal/Result')
        },





        // instansi management
        {
          path: 'masterdata/instansi-management',
          component: () => import('@/components/pages/master_data/management_instansi/Index'),
        },
        {
          path: 'masterdata/instansi-management/create',
          component: () => import('@/components/pages/master_data/management_instansi/Create')
        },
        {
          path: 'masterdata/instansi-management/edit/:id',
          component: () => import('@/components/pages/master_data/management_instansi/Edit')
        },


        // User management
        {
          path: 'masterdata/user-management',
          component: () => import('@/components/pages/master_data/management_user/Index')
        },
        {
          path: 'masterdata/user-management/create',
          component: () => import('@/components/pages/master_data/management_user/Create')
        },
        {
          path: 'masterdata/user-management/edit/:id',
          component: () => import('@/components/pages/master_data/management_user/Edit')
        },

        //Pelapor Management
        {
          path: 'masterdata/pelapor-management',
          component: () => import('@/components/pages/master_data/management_pelapor/Index')
        },
        {
          path: 'masterdata/pelapor-management/create',
          component: () => import('@/components/pages/master_data/management_pelapor/Create')
        },
        {
          path: 'masterdata/pelapor-management/edit/:id',
          component: () => import('@/components/pages/master_data/management_pelapor/Edit')
        },

        // Role management
        {
          path: 'masterdata/role-management',
          component: () => import('@/components/pages/master_data/management_role/Index')
        },
        {
          path: 'masterdata/role-management/create',
          component: () => import('@/components/pages/master_data/management_role/Create')
        },
        {
          path: 'masterdata/role-management/edit/:id',
          component: () => import('@/components/pages/master_data/management_role/Edit')
        },

        // Status Kepemilikan management
        {
          path: 'masterdata/kepemilikan-management',
          component: () => import('@/components/pages/master_data/management_kepemilikan/Index')
        },
        {
          path: 'masterdata/kepemilikan-management/create',
          component: () => import('@/components/pages/master_data/management_kepemilikan/Create')
        },
        {
          path: 'masterdata/kepemilikan-management/edit/:id',
          component: () => import('@/components/pages/master_data/management_kepemilikan/Edit')
        },

        // Golongan Fasyankes management
        {
          path: 'masterdata/fasyankes-management',
          component: () => import('@/components/pages/master_data/management_fasyankes/Index')
        },
        {
          path: 'masterdata/fasyankes-management/create',
          component: () => import('@/components/pages/master_data/management_fasyankes/Create')
        },
        {
          path: 'masterdata/fasyankes-management/edit/:id',
          component: () => import('@/components/pages/master_data/management_fasyankes/Edit')
        },

        // Termometer management
        {
          path: 'masterdata/termometer-management',
          component: () => import('@/components/pages/master_data/management_termometer/Index')
        },
        {
          path: 'masterdata/termometer-management/create',
          component: () => import('@/components/pages/master_data/management_termometer/Create')
        },
        {
          path: 'masterdata/termometer-management/edit/:id',
          component: () => import('@/components/pages/master_data/management_termometer/Edit')
        },


        // Storage management
        {
          path: 'masterdata/storage-management',
          component: () => import('@/components/pages/master_data/management_storage/Index')
        },
        {
          path: 'masterdata/storage-management/create',
          component: () => import('@/components/pages/master_data/management_storage/Create')
        },
        {
          path: 'masterdata/storage-management/edit/:id',
          component: () => import('@/components/pages/master_data/management_storage/Edit')
        },

        //container management
        {
          path: 'masterdata/container-management',
          component: () => import('@/components/pages/master_data/management_container/Index')
        },
        {
          path: 'masterdata/container-management/create',
          component: () => import('@/components/pages/master_data/management_container/Create')
        },
        {
          path: 'masterdata/container-management/edit/:id',
          component: () => import('@/components/pages/master_data/management_container/Edit')
        },


        // Workshop management
        {
          path: 'masterdata/workshop-management',
          component: () => import('@/components/pages/master_data/management_workshop/Index')
        },
        {
          path: 'masterdata/workshop-management/create',
          component: () => import('@/components/pages/master_data/management_workshop/Create')
        },
        {
          path: 'masterdata/workshop-management/edit/:id',
          component: () => import('@/components/pages/master_data/management_workshop/Edit')
        },

        // Sumber Dana management
        {
          path: 'masterdata/sumberdana-management',
          component: () => import('@/components/pages/master_data/management_sumberdana/Index')
        },
        {
          path: 'masterdata/sumberdana-management/create',
          component: () => import('@/components/pages/master_data/management_sumberdana/Create')
        },
        {
          path: 'masterdata/sumberdana-management/edit/:id',
          component: () => import('@/components/pages/master_data/management_sumberdana/Edit')
        },

        // Tensimeter Bermerkuri
        {
          path: 'masterdata/tensimeter-management',
          component: () => import('@/components/pages/master_data/tensimeter_bermerkuri/Index')
        },
        {
          path: 'masterdata/tensimeter-management/create',
          component: () => import('@/components/pages/master_data/tensimeter_bermerkuri/Create')
        },
        {
          path: 'masterdata/tensimeter-management/edit/:id',
          component: () => import('@/components/pages/master_data/tensimeter_bermerkuri/Edit')
        },

        //Termometer Pengganti
        {
          path: 'masterdata/termometer-pengganti',
          component: () => import('@/components/pages/master_data/termometer_pengganti/Index')
        },
        {
          path: 'masterdata/termometer-pengganti/create',
          component: () => import('@/components/pages/master_data/termometer_pengganti/Create')
        },
        {
          path: 'masterdata/termometer-pengganti/edit/:id',
          component: () => import('@/components/pages/master_data/termometer_pengganti/Edit')
        },

        //jenis sfigmomanometer
        {
          path: 'masterdata/jenis-sfigmomanometer',
          component: () => import('@/components/pages/master_data/jenis_sfigmomanometer/Index')
        },
        {
          path: 'masterdata/jenis-sfigmomanometer/create',
          component: () => import('@/components/pages/master_data/jenis_sfigmomanometer/Create')
        },
        {
          path: 'masterdata/jenis-sfigmomanometer/edit/:id',
          component: () => import('@/components/pages/master_data/jenis_sfigmomanometer/Edit')
        },

        //jenis sfigmomanometer meja
        {
          path: 'masterdata/jenis-sfigmomanometer-meja',
          component: () => import('@/components/pages/master_data/jenis_sfigmomanometer_meja/Index')
        },
        {
          path: 'masterdata/jenis-sfigmomanometer-meja/create',
          component: () => import('@/components/pages/master_data/jenis_sfigmomanometer_meja/Create')
        },
        {
          path: 'masterdata/jenis-sfigmomanometer-meja/edit/:id',
          component: () => import('@/components/pages/master_data/jenis_sfigmomanometer_meja/Edit')
        },

        //Pengganti Amalgam
        {
          path: 'masterdata/pengganti-amalgam',
          component: () => import('@/components/pages/master_data/pengganti_amalgam/Index')
        },
        {
          path: 'masterdata/pengganti-amalgam/create',
          component: () => import('@/components/pages/master_data/pengganti_amalgam/Create')
        },
        {
          path: 'masterdata/pengganti-amalgam/edit/:id',
          component: () => import('@/components/pages/master_data/pengganti_amalgam/Edit')
        },

        //Air Raksa di Kelola
        {
          path: 'masterdata/alkes-management',
          component: () => import('@/components/pages/master_data/alkes_management/Index')
        },
        {
          path: 'masterdata/alkes-management/create',
          component: () => import('@/components/pages/master_data/alkes_management/Create')
        },
        {
          path: 'masterdata/alkes-management/edit/:id',
          component: () => import('@/components/pages/master_data/alkes_management/Edit')
        },

        //LAPORAN
        {
          path: 'laporan',
          component: () => import('@/components/pages/Laporan/Index')
        },
        {
          path: 'export',
          component: () => import('@/components/pages/Export/Index')
        },
        {
          path: 'export/history',
          component: () => import('@/components/pages/Export/History')
        },

        //CMS
        {
          path: 'web-config',
          component: () => import('@/components/pages/cms/web_config/Index')
        },

        {
          path: 'inquiries',
          component: () => import('@/components/pages/cms/Inquiries/Index')
        },
        {
          path: 'inquiries/create',
          component: () => import('@/components/pages/cms/Inquiries/Create')
        },
        {
          path: 'inquiries/edit/:id',
          component: () => import('@/components/pages/cms/Inquiries/Edit')
        },
        {
          path: 'inquiries/detail/:id',
          component: () => import('@/components/pages/cms/Inquiries/Detail')
        },

        {
          path: 'banner',
          component: () => import('@/components/pages/cms/Banner/Index')
        },
        {
          path: 'banner/create',
          component: () => import('@/components/pages/cms/Banner/Create')
        },
        {
          path: 'banner/edit/:id',
          component: () => import('@/components/pages/cms/Banner/Edit')
        },

        {
          path: 'fitur',
          component: () => import('@/components/pages/cms/Fitur/Index')
        },
        {
          path: 'fitur/create',
          component: () => import('@/components/pages/cms/Fitur/Create')
        },
        {
          path: 'fitur/edit/:id',
          component: () => import('@/components/pages/cms/Fitur/Edit')
        },

        //media fitur
        {
          path: 'media/fitur/:fiturid',
          component: () => import('@/components/pages/cms/MediaFitur/Index')
        },
        {
          path: 'media/fitur/create/:fiturid',
          component: () => import('@/components/pages/cms/MediaFitur/Create')
        },
        {
          path: 'media/fitur/edit/:id',
          component: () => import('@/components/pages/cms/MediaFitur/Edit')
        },

        //tentang sipamer
        {
          path: 'tentang/sipamer',
          component: () => import('@/components/pages/cms/TentangSipamer/Index')
        },
        {
          path: 'tentang/sipamer/create',
          component: () => import('@/components/pages/cms/TentangSipamer/Create')
        },
        {
          path: 'tentang/sipamer/edit/:id',
          component: () => import('@/components/pages/cms/TentangSipamer/Edit')
        },

        //wms
        {
          path: 'wms',
          component: () => import('@/components/pages/cms/WMS/Index')
        },
        {
          path: 'wms/create',
          component: () => import('@/components/pages/cms/WMS/Create')
        },
        {
          path: 'wms/edit/:id',
          component: () => import('@/components/pages/cms/WMS/Edit')
        },

        //faq
        {
          path: 'faq',
          component: () => import('@/components/pages/cms/FAQ/Index')
        },
        {
          path: 'faq/create',
          component: () => import('@/components/pages/cms/FAQ/Create')
        },
        {
          path: 'faq/edit/:id',
          component: () => import('@/components/pages/cms/FAQ/Edit')
        },


        //notification
        {
          path: 'notification',
          component: () => import('@/components/pages/Notification/Index')
        },







        // PROFILE
        {
          path: 'profile',
          component: () => import('@/components/pages/profile/Index')
        },



      ]
    },

  ]
})

router.afterEach(() => {
  // Remove initial splash screen
  // const splashScreen = document.querySelector('.app-splash-screen')
  // if (splashScreen) {
  //   splashScreen.style.opacity = 0
  //   setTimeout(() => splashScreen && splashScreen.parentNode.removeChild(splashScreen), 200)
  // }

  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {

  const publicPages = ['/', '/lapor', '/lapor/pesk', '/register', '/tes', '/login', '/dms'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !loggedIn) {
    next('/');
  } else {
    next();
  }

  // Set loading state
  document.body.classList.add('app-loading')

})

export default router
/* eslint-disable */
